module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("gqWPS"))).then(() => parcelRequire('d0iPb'));